import React, { useState, useEffect, useRef } from 'react';
import './CodeEditor.css';

let backendURL = process.env.REACT_APP_BACKEND_WS_URL
if (backendURL == null){
    backendURL = "ws://localhost:8000"
}

const CodeEditor: React.FC = () => {
  const [text, setText] = useState('');
  const ws = useRef<WebSocket | null>(null); // Initialize the ref

  useEffect(() => {
    // Connect to WebSocket server
    console.log('Connecting to WebSocket server');
    ws.current = new WebSocket(backendURL + '/ws/student');

    ws.current.onopen = () => {
      console.log('WebSocket Connected');
    };

    ws.current.onmessage = (event) => {
      console.log('Message received: ', event.data);
    };

    ws.current.onclose = () => {
      console.log('WebSocket Disconnected');
    };

    ws.current.onerror = (error) => {
      console.error('WebSocket Error: ', error);
    };

    // Clean up on component unmount
    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, []);

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    console.log('handleTextChange: ', event.target.value);
    const newText = event.target.value;
    setText(newText);
    if (ws) {
      console.log('sending to ws: ', newText);
      ws.current?.send(newText);
    }
  };

  return (
    <div className="editor-container">
      <br/>
      <h1>Code Editor</h1>
      <div className="row">
        <div className="col-3"></div>
        <div className="col-6">
          <textarea className="form-control custom-textarea" value={text} onChange={handleTextChange} />
        </div>
      </div>
    </div>
  );
};

export default CodeEditor;
